import {Button, TextField} from "@mui/material";
import {useState} from "react";
import {manufacturerHersteller} from "../repository/category";
import {ReactComponent as SettingsIcon} from '../assets/settingsIcon.svg'
import {ReactComponent as AddIcon} from '../assets/add.svg'
import {ReactComponent as TrashIcon} from '../assets/trashIcon.svg'
import axios from "axios";
import {environment} from "../environment";
import {herstellerLoad} from "../repository/article";

type Props = {
    close: () => void
    manufacturers: manufacturerHersteller[]
    manufacturerList: manufacturerHersteller[];
    setManufacturerList: (hersteller: manufacturerHersteller[]) => void;
}

export default function ManufacturerPage(props: Props) {

    console.log(props.manufacturerList.length, props.manufacturers.length)

    const [searchText, setSearchText] = useState('')
    const [loading, setLoading] = useState<boolean>(false)

    function loadManufacturerData() {

        herstellerLoad().then((hersteller: manufacturerHersteller[]) => {
            console.log("HERSTELLER", hersteller.length);
            props.setManufacturerList(hersteller);
            setLoading(false);
        })

    }

    function addManufacturer(supData: manufacturerHersteller){
        supData.description = '';
        let supplierList = props.manufacturerList;
        supplierList.push(supData);
        saveManufacturerData([...supplierList]);
    }


    function removeSupplier(supData: manufacturerHersteller){

        const indexOfItem = props.manufacturerList.findIndex((item) => item.id === supData.id);
        if(indexOfItem !== -1){
            let supplierList = props.manufacturerList;
            supplierList.splice(indexOfItem, 1);
            saveManufacturerData(supplierList);
        }
    }

    function saveManufacturerData(promoData: manufacturerHersteller[]) {
        axios.put(environment.ownBackendURL + 'savedManufacturers', { content: props.manufacturerList }).then(res => {
            setLoading(true)
            loadManufacturerData()

        })
    }

    function getSearchResults(): manufacturerHersteller[] {
        return props.manufacturers.filter(manu => {

            if (props.manufacturerList.map((i) => i.id).includes(manu.id)) {
                return false;
            }

            let search = searchText.toLowerCase()
            return manu.name.toLowerCase().includes(search) ||
                manu.description?.toLowerCase().includes(search)
        });
    }


    return (
        <div>

            <div style={{
                height: 160, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around',
            }}>
                <Button onClick={() => props.close()} color="success" style={{ position: 'relative', width: 80 }} variant="contained">Zurück</Button>
                <h1>Filtered Manufacturers</h1>
            </div>

            <table className="customers">
                <tr>
                    <th>Name</th>
                    <th><SettingsIcon /></th>
                </tr>
                {loading &&
                    <tr key='delete'>
                        <div>Lädt...</div>
                    </tr>
                }
                {props.manufacturerList.map((supplier) => {

                    return (
                        <tr key={supplier.id?.toString() + "--p"}>

                            <td>{supplier.name}</td>
                            <td><Button onClick={() => removeSupplier(supplier)} color="primary" style={{ position: 'relative', width: 80 }} variant="contained">
                                <TrashIcon />
                            </Button></td>
                        </tr>
                    )
                })}
            </table>
            <div style={{ height: 2, backgroundColor: '#000', width: '95%', marginLeft: '2.5%', marginTop: 45, marginBottom: 45 }}></div>
            <div style={{
                height: 160, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-around',
            }}>
                <h1>All Manufacturers</h1>
                <TextField id="outlined-basic" label="Suche" variant="outlined" value={searchText} onChange={(event) => setSearchText(event.target.value)} />
            </div>
            <table className="customers">
                <tr>

                    <th>Name</th>
                    <th><SettingsIcon /></th>
                </tr>

                {getSearchResults().slice(0, 15).map((supplier) => {

                    return (
                        <tr key={supplier.id?.toString()}>

                            <td>{supplier.name}</td>
                            <td><Button onClick={() => addManufacturer(supplier)} color="primary" style={{ position: 'relative', width: 80 }} variant="contained">
                                <AddIcon />
                            </Button></td>
                        </tr>
                    )
                })}
            </table>
        </div >
    )
}
